<h2 mat-dialog-title>{{ fileName }}</h2>
<div *ngIf="!file || !fileUrl">
  <mat-spinner></mat-spinner>
</div>
<ng-container *ngIf="file && fileUrl">

  <mat-dialog-content>
    <div class="fileContainer">
      <ng-container *ngIf="fileType === 'img'">
        <img [src]="fileUrl" />
      </ng-container>

      <ng-container *ngIf="fileType === 'pdf'">
        <embed class="pdf" [src]="fileUrl" type="application/pdf" frameborder="0" />
      </ng-container>
    </div>

  </mat-dialog-content>

</ng-container>
<mat-dialog-actions>
  <ng-container *ngIf="file">
    <button mat-fab color="primary"
            (click)="downloadFile()">
      <mat-icon>save_alt</mat-icon>
    </button>
  </ng-container>
  <button mat-button mat-dialog-close>{{ 'cancel' | translate }}</button>
</mat-dialog-actions>

